import React from 'react';

import { upgrade } from '@/assets/icons';
import { S3ImageWrapper } from '@/components/shared/S3ImageWrapper/S3ImageWrapper';
import { Video } from '@/graphql';
import { timeFormatter } from '@/helpers/timeFormatter';
import { useSubscription } from '@/providers/SubscriptionProvider';
import { ButtonBase, SvgIcon } from '@material-ui/core';
import { Link } from 'react-router-dom';

import styles from './UpNextChip.module.scss';

export interface IUpNextChipProps {
	video: Video;
	currentlyWatched: boolean;
	link?: string;
}

export const UpNextChip: React.FC<IUpNextChipProps> = ({
	video,
	currentlyWatched,
	link,
}) => {
	const { status: subscriptionStatus, setPaidModalOpen } = useSubscription();

	const isPaidContent = subscriptionStatus ? false : video.paid;

	const upNextChipClasses = [
		styles['up-next-chip'],
		currentlyWatched ? styles['up-next-chip--currently-watched'] : '',
	];

	return (
		<div className={upNextChipClasses.join(' ')}>
			<div className={styles['up-next-chip__image']}>
				{/* <S3ImageWrapper imgKey={video.poster.key} lightSkeleton /> */}
				<img src={video.posterUrl} />
			</div>
			<div className={styles['up-next-chip__name']}>{video.name}</div>
			<div className={styles['up-next-chip__duration']}>
				{timeFormatter(video.duration)}
			</div>
			{isPaidContent && (
				<>
					<div
						className={styles['up-next-chip__paid-content-wrapper']}
					/>
					<div className={styles['up-next-chip__paid-content']}>
						<SvgIcon
							component={upgrade}
							classes={{
								root: styles['up-next-chip__paid-content-icon'],
							}}
						/>
					</div>
				</>
			)}
			{isPaidContent && (
				<ButtonBase
					focusRipple
					className={styles['up-next-chip__button']}
					onClick={() => setPaidModalOpen(true)}
					title={video.name}
				/>
			)}
			{!isPaidContent && !!link && (
				<ButtonBase
					focusRipple
					className={styles['up-next-chip__button']}
					component={Link}
					to={link}
					title={video.name}
				/>
			)}
		</div>
	);
};
